import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Container,
  TextField,
  Button,
  Alert
} from '@mui/material';
import { motion } from 'framer-motion';
import { useTeacherAuth } from '../auth/TeacherAuthContext'; // Assuming similar auth context as TeacherAllStudents

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const PublishNewsScreen = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { schoolId: contextSchoolId } = useTeacherAuth();
  const schoolId = state?.schoolId || contextSchoolId;
  const [title, setTitle] = useState('');
  const [details, setDetails] = useState('');
  const [publisher, setPublisher] = useState('');
  const [error, setError] = useState('');

  const handlePublishNews = async () => {
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
      return;
    }

    const newsData = {
      title,
      details,
      publisher,
      schoolId
    };

    try {
      const response = await axios.post('https://kidsm.vercel.app/api/schools/publish-news', newsData);
      if (response.status === 201) {
        navigate(-1);
      }
    } catch (error) {
      console.error('Error publishing news:', error);
      setError(error.response?.data?.message || 'Failed to publish news. Please try again.');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', pt: 8 }}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <motion.div variants={cardVariants} initial="hidden" animate="visible">
          <Typography
            variant="h4"
            sx={{ fontWeight: 'bold', color: '#333', mb: 4 }}
          >
            Publish News
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}
          <Box sx={{ bgcolor: 'white', p: 3, borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <TextField
              fullWidth
              label="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{ mb: 3 }}
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Details"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              multiline
              rows={6}
              sx={{ mb: 3 }}
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Publisher"
              value={publisher}
              onChange={(e) => setPublisher(e.target.value)}
              sx={{ mb: 3 }}
              variant="outlined"
            />
            <Button
              variant="contained"
              fullWidth
              sx={{ bgcolor: '#6200ee', py: 2 }}
              onClick={handlePublishNews}
            >
              Publish News
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default PublishNewsScreen;